"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redirect = function (url) {
    location.assign(url);
    return new Promise(function () { return undefined; });
};
//# sourceMappingURL=redirect.js.map